/* eslint-disable react/no-danger */
/* eslint-disable no-shadow */
import React, { useEffect, useRef, useState } from 'react'
import qs from 'qs'
import { Steps } from 'antd'
import { request } from 'meinian-package/src/utils'
import util from 'meinian-package/src/utils/util'
import { Feedback } from 'component'
import { Icon } from 'meinian-package/src/component'
import { Bubble } from 'meinian-package/src/baseComponent'
import classNames from 'classnames'
import './index.less'

const query = qs.parse(location.search, { ignoreQueryPrefix: true })
const { Step } = Steps
export default () => {
  const [data, setData] = useState([])
  const [post, setPost] = useState({})
  const [posts, setPosts] = useState([])
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(false)
  const [foldList, setFoldList] = useState([])
  const [appVisible, setAppVisible] = useState(true)
  const [titleList, setTitleList] = useState([])
  const [current, setCurrent] = useState(0)

  const isMounted = useRef(false)

  useEffect(() => {
    util.track('mn-inspiration-sidebar-page', {
      module1: '帮助中心',
    })
  }, [])

  useEffect(() => {
    document.title = '灵感集使用说明'
    setTimeout(() => {
      setAppVisible(false)
    }, 5 * 1000)
    fetchData()
  }, [])

  useEffect(() => {
    if (!isMounted.current) { isMounted.current = true; return }
    setPost(posts[index])
  }, [index])
  useEffect(() => {
    setCurrent(0)
    const title = []
    let count = 0
    const total = document.querySelectorAll('h1, h2, h3, h4, h5, h6')
    total.forEach((node) => {
      const list = title.map(m => m.tagName)
      if (!list.includes(node.localName) && count < 3) {
        count++
        title.push({ node, label: node.innerText, tagName: node.localName, className: `level-${count}` })
      } else {
        const item = title.find(m => m.tagName === node.localName)
        if (item) {
          title.push({ node, label: node.innerText, tagName: node.localName, className: item.className })
        }
      }
    })
    setTitleList([...title])
  }, [JSON.stringify(post)])
  const fetchData = async () => {
    try {
      const res = await request.get('/ins/inspiration/list-article')
      setData(res)
      const posts = []
      res.forEach((r) => {
        posts.push(...r.articleList)
      })
      setPosts(posts)
      const index = query.id ? posts.findIndex(m => m.id === Number(query.id)) : 0
      setIndex(index)
      setPost(posts[index])
    } catch (e) {
      console.error(e)
    }
  }
  return <div className="meinian-document">
    <div className="header">
      <a className="logo" href="/meinian/document">美念使用说明</a>
      <span style={{ display: 'flex' }}>
        <span className="header-item">
          <Bubble.Dropdown
            visible={appVisible}
            onVisibleChange={v => setAppVisible(v)}
            content={<div className="header-card">
              <img src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/meinian-image/zhiyi_app.png" alt="下载APP" width={114} style={{ marginBottom: 10 }} />
              <span className="txt-info">下载知衣APP<br />随时随地采集上传灵感</span>
            </div>}
          >APP下载</Bubble.Dropdown>
        </span>
        <span className="header-item" onClick={() => setVisible(true)}>意见反馈</span>
        <Feedback visible={visible} onClose={() => setVisible(false)} />
        <a href="/meinian/home/coll" target="_blank" className="header-button">进入美念</a>
      </span>
    </div>
    <div className="content">
      <aside>
        {data.map(m => <div className="ins-menu-wrapper">
          <div
            className={`menu-item ${foldList.includes(m.id) && m.articleList.map(a => a.id).includes(post.id) ? 'active' : ''}`}
            onClick={() => {
              foldList.includes(m.id) ? setFoldList(pre => [...pre.filter(p => p !== m.id)]) : setFoldList(pre => [...pre, m.id])
            }}
          ><span>{m.categoryName}</span>{foldList.includes(m.id) ? <Icon type="m-Vxing_xia" /> : <Icon type="m-Vxing_shang" />}</div>
          <ul className="submenu-wrapper" style={{ display: foldList.includes(m.id) ? 'none' : 'block' }}>
            {m.articleList.map(n => <li className={`submenu-item ${n.id === post.id ? 'active' : ''}`} onClick={() => setIndex(posts.indexOf(n))}>{n.title}</li>)}
          </ul>
        </div>)}
      </aside>
      <article>
        <div className="title">{post.title}</div>
        <div dangerouslySetInnerHTML={{ __html: post.desc }} style={{ paddingBottom: 136 }} />
        <div className="page-button">
          {index > 0 ? <span onClick={() => { setIndex(pre => (pre - 1)) }}>上一篇</span> : null}
          {index < posts.length - 1 ? <span onClick={() => { setIndex(pre => (pre + 1)) }}>下一篇</span> : null}
        </div>
      </article>
      <div className="document-title-guide" style={{ width: 236 }}>
        <Steps progressDot current={current} direction="vertical">
          { titleList?.map((m, index) => <Step title={<div className={classNames(`title ${m.className}`)} onClick={() => { setCurrent(index); m.node.scrollIntoView() }} dangerouslySetInnerHTML={{ __html: m.label }} />} />) }
        </Steps>
      </div>

    </div>
  </div>
}
